/**
 * Main AAF playing state
 */
export const AAFPLAYER_PLAY = 'PLAYING';
export const AAFPLAYER_STOP = 'STOPPING';

/**
 * Tipos de contenido que se playean
 * El "grabado", debería ser del tipo VOD?
 */
export const AAF_CONTENT_IS_NPVR = 'content_is_npvr';
export const AAF_CONTENT_IS_VOD = 'content_is_vod';
export const AAF_CONTENT_IS_CATCHUP = 'content_is_catchup';
export const AAF_CONTENT_IS_STARTOVER = 'content_is_startover';
export const AAF_CONTENT_IS_TIMESHIFT = 'content_is_timeshift'; // Este pronto se deprecará
export const AAF_CONTENT_IS_TV = 'content_is_tv';
export const AAF_CONTENT_IS_AUDIO = 'content_is_audio';
export const AAF_CONTENT_IS_RADIO = 'content_is_radio';
export const CONTENT_TYPES_ON_LIVE = [
  AAF_CONTENT_IS_CATCHUP,
  AAF_CONTENT_IS_STARTOVER,
  AAF_CONTENT_IS_TV,
];
/**
 * TODO Este debería ser el único lugar donde se definen las constantes de abajo
 * Tipos de streaming
 */
export const SS = 'smooth_streaming';
export const DASHWV = 'dashwv';
export const DASHWV_MA = 'dashwv_ma';
export const DASHPR = 'dashpr';
export const DASHPR_MA = 'dashpr_ma';
export const SS_MA = 'smooth_streaming_ma';
export const HLS = 'hls';
export const HLS_MA = 'hls_ma';
export const HLS_KR = 'hls_kr';
export const HLSPRM = 'hlsprm';
export const IP_MULTICAST = 'ip_multicast';
export const IP_MULTICAST_UDP = 'ip_multicast_udp';
export const IP_MULTICAST_LMS = 'ip_multicast_lms';
export const DVBC = 'dvbc';
export const DVBS = 'dvbs';
export const WVC = 'widevine_classic';
export const AUDIO = 'audio';
export const RADIO = 'radio';
export const SPOT = 'spot';
export const PLAYERIMAGE = 'image';
export const DASH_CMAF = 'dash_cmaf';

/**
 * Tipos de logging messages
 */
export const LOG_BASIC = 0;
export const LOG_WARNING = 1;
export const LOG_ERROR = 2;
export const LOG_INFO = 3;

/**
 * Time retry playing
 */
export const retryTimeEventsAndroid = 11000; // Se cambia a 11 segs + los 4.5 segs que tarda el interval android = 15.5 segs, osea mas o menos como estaba, en 15 segs.
export const retryTimeEvents = 15000;
export const retryTimeEventsFirstTime = 180000;

/**
 * PGM errors para saber si reintentar llamada pgm hasta encontrar un streamType soportado por el device
 */
export const PLY_PLY_00009 = 'PLY_PLY_00009'; // Content is not available in the requested format
export const PLY_PLY_00001 = 'PLY_PLY_00001'; // Invalid stream type
export const PLY_TIMEOUT = '28'; // Invalid stream type

// Border color general in input outfocus
export const INPUT_STYLE_OUTFOCUS = '3px solid #4C6F94';

//Mundial
export const QATAR2022ENABLED = 'qatar2022_enabled';
export const MUNDIAL2022 = 'mundial2022';
export const KEYQATAR2022DEFAULT = '{"default": {"enable": {"susc": true,"no_susc": true,"anonymous": false},"interval_time": 60}}';

export const APIVERSION = 'v5.94';
export const SUPPORTEDSTREAMTYPE = 'supported_stream_time';
export const SUPPORTEDSTREAMTYPEBITMOVIN = 'supported_stream_type_bitmovin';
export const DEFAULT = 'default';
export const LIVE = 'live';
export const REGION = 'region';
export const HOMEUSER = 'homeuser';

export const CONTAINER_VIDEO_BUTTON_SKIP_ADS = 'vcontainer';
export const ID_BUTTON_SKIP_ADS = 'button-skip-ads';
export const SW_SECURE_CRYPTO = "SW_SECURE_CRYPTO";

export const RENT = 'rent';
export const BUY = 'buy'
export const COLORFILTERBUTTON = '#2e303d';





// WEBPACK FOOTER //
// ./src/AAFPlayer/constants.js